import React from "react";
import { Tooltip } from "@mui/material";
import {
  ArrowTopRightOnSquareIcon,
  BookOpenIcon,
} from "@heroicons/react/24/solid";
import Button from "components/UI-lib/Button";
import { classNames } from "components/utils";

export interface EnvironmentCTAButton {
  hostname?: string;
  label: string;
  isHealthy: boolean;
}

export interface EnvironmentJupyterButton {
  hostname?: string;
  isHealthy: boolean;
}

interface EnvironmentCTAButtonsProps {
  ctaButtons: EnvironmentCTAButton[];
  jupyter?: EnvironmentJupyterButton;
  startupScriptFailed?: boolean;
  onOpenNotebook?: () => void;
}

const EnvironmentCTAButtons: React.FC<EnvironmentCTAButtonsProps> = ({
  ctaButtons,
  jupyter,
  startupScriptFailed = false,
  onOpenNotebook,
}) => (
  <div className="flex flex-row items-center gap-3">
    {ctaButtons.map(({ hostname, label, isHealthy }) => (
      <div key={hostname || label}>
        <Tooltip
          title={
            !isHealthy
              ? `${label} not yet available (initialization may take several minutes after instance starts)`
              : startupScriptFailed
                ? `Setup script failed — ${label} may not work correctly`
                : ""
          }
          placement="top"
        >
          <span>
            <Button
              className={classNames(isHealthy ? "pulse-ready-button" : "")}
              label={label}
              type={isHealthy ? "primary" : "secondary"}
              loading={false}
              onClick={() => {
                if (!isHealthy || !hostname) return;
                window.open("https://" + hostname, "_blank");
              }}
              disabled={!isHealthy}
              iconLeft={
                <ArrowTopRightOnSquareIcon
                  className="-ml-1 mr-2 h-5 w-5 text-white"
                  aria-hidden="true"
                />
              }
            />
          </span>
        </Tooltip>
      </div>
    ))}
    {jupyter && (
      <div>
        <Tooltip
          title={
            !jupyter.hostname
              ? "Notebook endpoint is still loading"
              : !jupyter.isHealthy
                ? "Notebook not yet available (initialization may take several minutes after instance starts)"
                : startupScriptFailed
                  ? "Setup script failed — the notebook may not work correctly"
                  : ""
          }
          placement="top"
        >
          <span>
            <Button
              className={classNames(
                jupyter.isHealthy ? "pulse-ready-button" : "",
              )}
              label="Open Notebook"
              type={jupyter.isHealthy ? "primary" : "secondary"}
              loading={false}
              onClick={() => {
                if (!jupyter.isHealthy || !jupyter.hostname) return;
                onOpenNotebook?.();
              }}
              disabled={!jupyter.isHealthy || !jupyter.hostname}
              iconLeft={
                <BookOpenIcon
                  className="-ml-1 mr-2 h-5 w-5 text-white"
                  aria-hidden="true"
                />
              }
            />
          </span>
        </Tooltip>
      </div>
    )}
  </div>
);

export default EnvironmentCTAButtons;
